import React from 'react';

import NavigationButtonIcon from '../NavigationButtonIcon';
import { ButtonArea, Container, Content } from './styles';

interface CalendarHeaderProps {
  children: React.ReactNode;
  onPrevious: () => void;
  onNext: () => void;
  onModeChange: () => void;
}

export default function CalendarHeader(props: CalendarHeaderProps) {
  const { children, onNext, onPrevious, onModeChange } = props;

  return (
    <Container>
      <ButtonArea aria-label='previous-month-year' onClick={onPrevious}>
        <NavigationButtonIcon direction='left' />
      </ButtonArea>

      <Content aria-label='month-year-button' onClick={onModeChange}>
        {children}
      </Content>

      <ButtonArea aria-label='next-month-year' onClick={onNext}>
        <NavigationButtonIcon direction='right' />
      </ButtonArea>
    </Container>
  );
}
